import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { CampaignList } from '../../../models/campaignList.model';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { CalendarTranslate } from '../../../models/calendarTranslate.model';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { Campaign } from '../new-campaign/campaign';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-campaignlist',
  templateUrl: 'campaignlist.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    CampaignService
  ],
  styleUrls: ['./campaignlist.component.css']
})
export class CampaignlistComponent implements OnInit {

  public calendarTranslate: CalendarTranslate;
  public errors: Array<any>;
  private urlParams: any;
  public campaignList: Array<CampaignList>;
  public campaignListPage: Array<CampaignList>;
  public pagination: { total: number, step: number };

  public budget: string;
  public budgetPercentage: number;
  public timePercentage: number;

  public filterName: string;
  public filterFromDate: Date;
  public filterToDate: Date;
  public filterStatus: string;
  public filterTypes: SelectItem[];
  public filterSelectedType: string;
  public filterStores: SelectItem[];
  public filterSelectedStore: string;
  public filterSort: SelectItem[];
  public filterSelectedSort: number;
  public filterStatusButtons: SelectItem[];

  public deleteCampaignConfirmHeader: string;
  public deleteCampaignConfirmMsg: string;


  constructor(
    private campaignService: CampaignService,
    private translateService: TranslateService,
    public calendarService: CalendarTranslateService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService
  ) {
    this.filterStatus = 'all';

    this.campaignService.getStoresFromFilters({
      area: [],
      gruppo: "",
      insegna: [],
      codici: []
    }).subscribe(res => {
      for(let store of res) {
        this.filterStores.push({ label: '[' + store.id + '] ' + store.name, value: store.id });
      }
    });

    this.filterSelectedSort = 1;
    this.filterSort = [
      { label: 'Precedenti', value: -1 },
      { label: 'Recenti', value: 1 }
    ];

    this.translateService.get([
      'campaign.deleteCampaignConfirmHeader',
      'campaign.deleteCampaignConfirmMsg',
      'common.all',
      'campaign.created',
      'campaign.inSummary',
      'campaign.defined',
      'campaign.inProgress',
      'campaign.done',
      'campaign.ready',
      'campaign.closed',
      'campaign.evaluated',
      'campaign.deleted',
      'campaign.recurrent',
      'campaign.allStores'
    ]).subscribe(res => {
      this.deleteCampaignConfirmHeader = res['campaign.deleteCampaignConfirmHeader'];
      this.deleteCampaignConfirmMsg = res['campaign.deleteCampaignConfirmMsg'];
      this.filterStatusButtons = [
        { label: res['common.all'], value: 'all' },
        { label: res['campaign.created'], value: Campaign.STATUS_CREATED },
        { label: res['campaign.inSummary'], value: Campaign.STATUS_SUMMARY },
        { label: res['campaign.defined'], value: Campaign.STATUS_DEFINED },
        { label: res['campaign.inProgress'], value: Campaign.STATUS_GENERATING },
        { label: res['campaign.done'], value: Campaign.STATUS_ELABORATA },
        { label: res['campaign.ready'], value: Campaign.STATUS_READY },
        { label: 'Live', value: Campaign.STATUS_LIVE },
        { label: res['campaign.closed'], value: Campaign.STATUS_CONCLUDED },
        { label: res['campaign.evaluated'], value: Campaign.STATUS_EVALUATED },
        { label: res['campaign.deleted'], value: Campaign.STATUS_ELIMINATA },
      ];
      this.filterTypes = [
        { label: res['common.all'], value: null },
        { label: res['campaign.recurrent'], value: Campaign.TYPE_RECURRING },
        { label: 'One Shot', value: Campaign.TYPE_ONE_SHOT }
      ];
      this.filterStores = [];
      this.filterStores.push({ label: res['campaign.allStores'], value: null });
    });

    this.calendarService.pCalendar.subscribe(res => {
      this.calendarTranslate = res;
    });
  }

  ngOnInit()
  {
    this.errors = [];
    const saved = this.route.snapshot.queryParams['saved'];

    if(typeof saved !== 'undefined' && saved === 1) {
      this.translateService.get('campaign.confirm').subscribe(message => {
        this.errors.push({
          severity: 'success',
          summary: 'Ok!',
          detail: message
        });
      });
    }

    Observable.zip(
      this.campaignService.getCampaignYearBudget(2016),
      this.campaignService.getScheduledYearBudget(2016),

    ).subscribe(([ totalBudget, scheduledBudget ]) => {

      const start = moment().day(1).month('January');
      const end = moment().endOf('day');
      const days = end.diff(start, 'days');

      this.budget = totalBudget;
      this.timePercentage = Math.round(days / 365 * 100);
      this.budgetPercentage = Math.min(100, Math.round(totalBudget * 100 / scheduledBudget));
    });

    this.campaignList = [];
    this.campaignFilter();
  }

  setStatus(status: string)
  {
    this.filterStatus = status;
    this.campaignFilter();
  }

  campaignFilter()
  {
    let params: any = {};

    if(typeof this.filterFromDate !== 'undefined') {
      params.from_date = moment(this.filterFromDate).format('YYYY-MM-DD');
    }
    if(typeof this.filterToDate !== 'undefined') {
      params.to_date = moment(this.filterToDate).format('YYYY-MM-DD');
    }
    if(typeof this.filterSelectedType !== 'undefined') {
      params.type = this.filterSelectedType;
    }
    if(typeof this.filterSelectedStore !== 'undefined') {
      params.store = this.filterSelectedStore;
    }

    this.campaignService.campaignList(params).subscribe(res =>
    {
      this.campaignList = res
        .filter(campaign => campaign.periodo_emissione_campagna)
        .map(campaign => this.parseCampaign(campaign))
        .filter(campaign => {
          // Filtra Campagne per Stato
          let status = this.filterStatusButtons.find(status => status.value == campaign.campaign_state);
          if(typeof status === 'undefined') {
            return false;
          } else {
            // Se selezionato filtro "all", mostra tutte le campagne tranne le eliminate
            if (this.filterStatus === 'all' && campaign.campaign_state != 'ELIMINATA') {
              return this.filterStatus === 'all'
              // Per tutti gli altri filtri mostra solo le campagne nel relativo stato
            } else {
              return campaign.campaign_state == this.filterStatus;
            }
          }
        })
        .filter(campaign => {
          if(typeof this.filterName === 'undefined') {
            return true;
          }
          return campaign.campaign_name.toLowerCase().includes(this.filterName.toLowerCase());
        })
        .map(campaign => {
          let status = this.filterStatusButtons.find(status => status.value == campaign.campaign_state);
          campaign.campaign_state = status.label;
          campaign.campaign_state_key = status.value;
          return campaign;
        })
        .sort((campaign_a, campaign_b) => {
          return (campaign_b.start_date.getTime() - campaign_a.start_date.getTime()) * this.filterSelectedSort;
        });

      this.pagination = {
        total: this.campaignList.length,
        step: 10
      };

      this.paginate({ page: 0 });
    });
  }

  parseCampaign(campaign: CampaignList)
  {
    let dates = campaign.periodo_emissione_campagna.split(' - ');
    campaign.start_date = moment(dates[0], 'DD/MM/YYYY').toDate();
    campaign.end_date = moment(dates[1], 'DD/MM/YYYY').toDate();


    if(campaign.campaign_state === Campaign.STATUS_SENT_KCM)
    {
      if(moment().isBefore(campaign.start_date)) {
        campaign.campaign_state = Campaign.STATUS_READY;

      } else if(moment().isBetween(campaign.start_date, campaign.end_date, null, '[]')) {
        campaign.campaign_state = Campaign.STATUS_LIVE;

      } else if(moment().isAfter(campaign.end_date)) {
        campaign.campaign_state = Campaign.STATUS_CONCLUDED;
      }
    }

    campaign.campaign_state_key = campaign.campaign_state;

    switch(campaign.campaign_type)
    {
      case Campaign.TYPE_ONE_SHOT:
        campaign.campaign_type_name = 'One Shot';
        break;

      case Campaign.TYPE_RECURRING:
        campaign.campaign_type_name = 'Ricorrente';
        break;
    }

    switch(campaign.campaign_state)
    {
      case Campaign.STATUS_CREATED:
      case Campaign.STATUS_APPROVED:
      case Campaign.STATUS_DEFINED:
      case Campaign.STATUS_SUMMARY:
        campaign.actions = [
          { label: 'edit', value: { link: '/new-campaign/1', icon: 'pencil' } }
        ];
        break;

      case Campaign.STATUS_ELABORATA:
        campaign.actions = [
          { label: 'summary', value: { link: '/campaign/summary', icon: 'eye' } }
        ];
        break;

      case Campaign.STATUS_LIVE:
      case Campaign.STATUS_CONCLUDED:
        campaign.actions = [
          { label: 'live evaluation', value: { link: '/campaign/live-evaluation', icon: 'eye' } }
        ];
        break;

      case Campaign.STATUS_EVALUATED:
        campaign.actions = [
          { label: 'final evaluation', value: { link: '/campaign/final-evaluation', icon: 'eye' } }
        ];
        break;
    }

    return campaign;
  }

  deleteCampaign(campaignName: string) {
    this.confirmationService.confirm({
      header: this.deleteCampaignConfirmHeader,
      message: this.deleteCampaignConfirmMsg,
      accept: () => this.campaignService.deleteCampaign(campaignName).subscribe(),
      acceptLabel: "Ok",
      rejectLabel: "Annulla"
    })
  }

  paginate(event)
  {
    const page = event.page;
    const start = page * this.pagination.step;
    this.campaignListPage = this.campaignList.slice(start, start + this.pagination.step);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/campaignlist/campaignlist.component.ts